import { render, staticRenderFns } from "./noticeManagement.vue?vue&type=template&id=4bd6602e&"
import script from "./noticeManagement.vue?vue&type=script&lang=js&"
export * from "./noticeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports